/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckPlayableAdsExistResponse
 */
export interface CheckPlayableAdsExistResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CheckPlayableAdsExistResponse
     */
    _exists?: boolean;
}

/**
 * Check if a given object implements the CheckPlayableAdsExistResponse interface.
 */
export function instanceOfCheckPlayableAdsExistResponse(value: object): value is CheckPlayableAdsExistResponse {
    return true;
}

export function CheckPlayableAdsExistResponseFromJSON(json: any): CheckPlayableAdsExistResponse {
    return CheckPlayableAdsExistResponseFromJSONTyped(json, false);
}

export function CheckPlayableAdsExistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckPlayableAdsExistResponse {
    if (json == null) {
        return json;
    }
    return {
        
        '_exists': json['exists'] == null ? undefined : json['exists'],
    };
}

export function CheckPlayableAdsExistResponseToJSON(json: any): CheckPlayableAdsExistResponse {
    return CheckPlayableAdsExistResponseToJSONTyped(json, false);
}

export function CheckPlayableAdsExistResponseToJSONTyped(value?: CheckPlayableAdsExistResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exists': value['_exists'],
    };
}

